var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
export class LightGalleryComponent extends Component {
    constructor() {
        super('LightGalleryComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.light-gallery').forEach((item) => __awaiter(this, void 0, void 0, function* () {
                var captions;
                const lg = lightGallery(item, {
                    selector: '.light-gallery-item',
                    download: false,
                    hideBarsDelay: 0,
                    thumbnail: ($(item).hasClass('no-thumbnails')) ? false : true,
                    exThumbImage: 'data-thumbnail',
                    animateThumb: false,
                    showThumbByDefault: false,
                    mode: 'lg-fade',
                    loop: false,
                    enableSwipe: true
                });
                console.log(lg);
                captions = yield $.httpRequest({
                    url: '?post_id=' + $(item).data('postId') + '&module_gallery=' + $(item).data('module'),
                    dataType: 'json',
                });
                $(item).on('onAfterAppendSubHtml', (e) => {
                    $('.lg-sub-html').removeClass('lg-empty-html').html(captions[e.detail.index]);
                });
            }));
            $('body').on('wheel', (event) => {
                if ($('.lg-outer').length == 0)
                    return;
                let isThumbOpened = ($('.lg-outer').hasClass('lg-thumb-open')) ? true : false;
                if ((isThumbOpened && event.deltaY < 0) || (!isThumbOpened && event.deltaY > 0))
                    $('.lg-toggle-thumb').trigger('click');
            });
            $('body').on('click', '.button-scroll-gallery-down', (event, item) => {
                const to = ($(item).parents('.lg').get(0).scrollTop == 0) ? $(item).parents('.lg').get(0).scrollHeight - document.documentElement.clientHeight : 0;
                $.scrollTo(to, 500, $(item).parents('.lg').get(0));
            });
            $('body').on('click', '.lg-thumb-item', (event, item) => {
                $('.lg-outer').removeClass('lg-thumb-open');
            });
            this.success();
        });
    }
}
